<template>
  <div>
    <!-- <v-sheet> -->
    <v-container class="py-4 py-lg-8">
      <div class="text-center">
        <div class="text-uppercase font-weight-bold body-2 primary--text mb-2">
          Support
        </div>
        <h2 class="text-h3 text-lg-h2">Frequently Asked Questions</h2>
        <v-responsive max-width="1200" class="mx-auto">
          <div class="text-h6 text-lg-h5 mt-4">{{ subtitle }}</div>
        </v-responsive>
      </div>

      <v-expansion-panels v-model="panel" multiple class="mt-8">
        <v-expansion-panel v-for="(item, i) in faq" :key="i">
          <v-expansion-panel-header class="text-h5">
            {{ item.question }}
          </v-expansion-panel-header>
          <v-expansion-panel-content class="text-h6 secondary--text">
            {{ item.answer }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <!-- </v-sheet> -->
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "FAQ",
    titleTemplate: "Strapp - FAQs 📠",
    content:
      "An online rental marketplace where you can rent out your household items and equipment to others for short term periods.",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },
  data: () => ({
    faq: [
      {
        question: "How do you price the items for rental?",
        answer:
          "We automatically suggest rental fee limits when you fill out the listing form with us. We also recommend taking a look at what similar items sell for new and second hand, as well as what they may be rented out for elsewhere. This should give you an idea of what you can rent it out for. Remember, the lower the weekly and monthly fee, the more likely someone is to rent out your item for a longer period. ",
      },
      {
        question: "Do I need to pay a deposit on my rentals? ",
        answer:
          "Depending on the listing, some listings require a deposit to be held whilst the item is rented out. Strapp will collect the deposit from the borrower and will be held until the end of the rental period. Once the item has been returned, the item owner will do an inspection of the item, and as long as it is in roughly the same condition as it was rented out in, your deposit will be paid back to you within 24 hours. ",
      },
     {
        question: "When do I need to pay?",
        answer:
          "You can proceed to payment once you have placed a booking and the lender has approved your booking. Here you will receive an invoice from us and a payment method to finalise the booking (PayFast or Stitch)",
      },
      {
        question: "Can I place a booking without paying?",
        answer:
          "Yes you most certainly can! When you place a booking, the lender will confirm it’s availability. Only once it has been confirmed do you need to complete the payment. You can alternatively cancel the booking at this point in time.",
      },
     
     
     {
        question: "What if someone damages the item that you rent to them?",
        answer:
          "We advise the item owner to inspect the item with the borrower once it has been given back to them. We also advise the item owner to insure more expensive items before renting them out. Strapp is not responsible for any damages or breakages or rented out items. The borrower is responsible for any damages that occur to the item that they borrow, except for ordinary wear and tear. In the case of a deposit, the deposit will be paid out to the owner for all damages incurred. ",
      },
      {
        question: "How does delivery work?",
        answer:
          "Delivery is decided between the lender and the borrower. A mutual agreement should be decided on who should pick up and return the item to each other. All delivery charges must be indicated in the listing and included in the rental fee and should not be an additional cost. ",
      },
      {
        question: "What costs are associated with using Strapp?",
        answer:
          "If you are borrowing an item, we charge you a 10% service fee for processing your booking and payment. If you are a lender, we charge you 10% service fee for processing your booking and payment. These are the only costs associated with using Strapp.",
      },
      {
        question: "How sure are you that I will get bookings?",
        answer:
          "While we can’t guarantee that you will get bookings, but we will try our best to get your items listing in front of as many people as possible. The number of bookings you receive may depend on your pricing, the item itself, the item category, and much more. We do encourage you to share your listing on your own social channels to direct people to your item on our platform to increase the chances of a booking request.",
      },
      {
        question: "Why do I need to submit documentation to verify my account?",
        answer:
          "We verify both the borrower and the item owner in order to create a safe renting transaction for both parties. You only need to submit proof of address, pic of ID and selfie of you holding your ID in order to verify your account and this only needs to be done once. This information is not shared with anyone and is only used to verify your identity and may be used to validate your details with home affairs and credit bureaux's.",
      },
      {
        question: "What time do I need to return the item?",
        answer:
          "One day's rental is counted a 24 hour period from the time you picked up the item. That means if you rented an item for one day and picked it up at 10am Monday, the default is that the item would be due back on 10am Tuesday - unless you and lender have agreed in writing to an alternative time. It's important that you return the items on time as many of our lenders have back to back rentals. Lenders are entitled to request late fees should you return the items after the return time. ",
      },
      {
        question: "How does payment work?",
        answer:
          "If you are borrowing an item from someone, you need to make sure to pay for the item at least 48 hours before the start of the booking. Once you have verified your account, we will send you a secure PayFast link via email where you can securely complete the payment. Your booking dates are only finalised once you have completed the payment for the booking. ",
      },
      {
        question: "When do I receive my rental fee from Strapp for my rental?",
        answer:
          "Once the booking has been finalised and we have received payment from the borrower, we wait until we receive confirmation that the borrower has collected the item. Once we have received this confirmation, we then payout the rental fee to the item owner within 24 hours from the start of the booking. ",
      },
      {
        question: "Are the items insured?",
        answer:
          "No, currently the items that are listed are not insured by Strapp. This is something we are actively investigating. We do however enable you to ask for a safety deposit that we will hold and manage for you. In the mean time we do recommend that the more expensive items that are listed should be insured.  ",
      },
      {
        question: "How do ratings and reviews work?",
        answer:
          "After each booking has been completed, we ask both the borrower and lender to complete a rating and review of each of their experiences with the item and the corresponding person. These rating and reviews are important for your profile as well as the item. Rating and reviews are stored on your profile as well as the actual item.",
      },
      {
        question: "What is the Proof of Life image upload?",
        answer:
          "These are quality assurance images that a lender uploads just before the booking of their item begins so that they can prove the state the item was in before it has been handed over to the borrower. This is so that we can confirm its current functional state so that if there is any damage to an item, we have some images to compare it back to. A booking is only complete once both users have added a rating and review",
      },
      {
        question: "Can I cancel the booking after receiving the item?",
        answer: "If the borrower cancels after they have picked up the item, there will be a 30% cancellation fee and they will receive a 70% refund of the rental fees for any remaining nights and the Strapp service fee will not be refunded. However, they will still pay for any days spent."
      }
      
      // {
      //   question: "How does delivery work?",
      //   answer:
      //     "Delivery is decided between the lender and the borrower. A mutual agreement should be decided on who should pick up and return the item to each other. All delivery charges must be included in the rental fee and should not be an additional cost if it is originally offered by the lender that they can deliver or organize delivery."
      // }
    ],
  }),
};
</script>

<style lang="scss" scoped></style>
